import { QueryClient } from "@tanstack/react-query";

// Single client for the app's lifetime. Exported as a module singleton so
// non-React code (e.g. prefetching in main.tsx) can warm the cache too.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "offlineFirst",
      refetchOnWindowFocus: false,
      retry: false,
      // staleTime: 1000 * 60 * 5,
      staleTime: 0,
      // Keep entries in memory for 24h so they aren't garbage-collected
      // before the localStorage persister can restore/re-save them.
      // Must be >= the persister maxAge (see query-persister.ts).
      gcTime: 1000 * 60 * 60 * 24,
    },
  },
});
